import React, { Component } from 'react';

class PinterestAnalyticsTracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pintrk: null,
    };

    this.handlePinterestClick = this.handlePinterestClick.bind(this);
  }

  componentDidMount() {
    if (window.pintrk) {
      this.setState({
        pintrk: window.pintrk,
      });
    }
  }

  handlePinterestClick() {
    // console.log(this.props.leadName, this.props.children.props);
    const { leadName, shopSlug } = this.props;
    this.state.pintrk('track', 'lead', {
      lead_type: leadName,
      property: shopSlug,
    }, function(didInit, error) {
      if (!didInit) {
        console.log(error);
      }
    });
  }

  render() {
    const { children, className } = this.props;

    return (
      <div
        onClick={this.handlePinterestClick}
        className={className}
      >
        { children }
      </div>
    );
  }
}

export default PinterestAnalyticsTracker;
